import React from 'react'

const Footer = () => {
    return (
        <footer>
            <h2>Heya Follow <i className="fa fa-angle-down" aria-hidden="true"></i></h2>
            <h3>Scribbling Pens</h3>
            <a href="https://www.instagram.com/scribblingpens/" >
                <i className="fa fa-instagram" aria-hidden="true"></i>
            </a>
        </footer>
    )
}

export default Footer
